<template>
  <sweet-modal ref="welcomeModal" overlay-theme="dark" width="1200px">
    <!-- <img src="./../../assets/images/welcome-modal-img.png" alt="Modal Image" class="modal-image" /> -->
    <a
      href="http://www.weterynariaprzyszlosci.pl"
      class="sweet-box-link"
      target="_blank"
    >Odwiedź stronę &raquo;</a>
  </sweet-modal>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";

export default {
  name: "WelcomeModal",
  components: {
    SweetModal
  },
  methods: {
    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  },
  mounted() {
    if (!this.getCookie("popup")) {
      this.$refs.welcomeModal.open();
      this.setCookie("popup", "cookie", 30);
    }
  }
};
</script>

<style>
.sweet-modal {
  height: 700px;
  padding: 50px;
}
.sweet-content {
  height: 100%;
}

.sweet-modal.theme-light {
  /* margin: 0 auto; */
}

.sweet-content {
  background-image: url(./../../assets/images/welcome-modal-img.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.sweet-box-link {
  position: absolute;
  bottom: 15px;
  right: 20px;
  text-decoration: underline;
  color: #222c38;
}

@media (max-width: 1200px) {
  .sweet-modal {
    height: 600px;
    width: 1000px !important;
  }
}
@media (max-width: 900px) {
  .sweet-modal {
    width: 100vw !important;
    height: 550px;
    padding: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/template/WelcomeModal.vue